export const REACT_APP_BASE_BE_URL = `https://api.${window.location.host.split('.').shift()}.zoominfo.com`;
export const REACT_APP_BASE_FE_URL = `https://${window.location.host.split('.').shift()}.zoominfo.com/`;
export const MICROSOFT_CLIENT_ID = window.location.host.split('.').shift() === "schedule"
    ?
    "8a48c7a8-74ca-4489-9f19-afc7a46d233d"
    :
    "c0a3cc6f-fa0d-4380-8b89-355ac7866a02"
;

export const GOOGLE_CLIENT_ID = window.location.host.split('.').shift() === "schedule"
    ?
    "134721002487-j7ffrgvpltfhagot4ijpv47j4960jdnm.apps.googleusercontent.com"
    :
    "55294326828-6tm7pir4vbt3n9khrorclt0lfsbo6437.apps.googleusercontent.com";

export const CAPTCHA_SITE_KEY = window.location.host.split('.').shift() === "schedule"
    ?
    "6Ld8jsgqAAAAAHsHqzHELhtz7FCpYgj_29XnWW1d"
    :
    "6Lf-AcgqAAAAAIVCRjmA54D_xiEwxXhKPSmuQteM"